import React from 'react';
import { Card, Row, Col } from 'antd';
import { FileAddOutlined, TeamOutlined, CheckCircleFilled, SafetyCertificateFilled } from '@ant-design/icons';

const tx = {
  ar: {
    title: 'كيف تعمل لانسر سيتي؟',
    subtitle: 'ثلاث خطوات بسيطة من فكرتك إلى التسليم',
    steps: [
      { icon: <FileAddOutlined />, title: 'انشر مشروعك', body: 'صف ما تحتاج، حدد الميزانية والوقت، واستلم العروض.' },
      { icon: <TeamOutlined />,    title: 'اختر المستقل المناسب', body: 'قارن السير الذاتية والتقييمات وتحدث معه قبل القرار.' },
      { icon: <CheckCircleFilled />, title: 'تابع وادفع بأمان', body: 'الدفع يبقى محتجزاً في الضمان حتى تستلم وتوافق على العمل.' },
    ],
  },
  en: {
    title: 'How LancerCity works',
    subtitle: 'Three steps from your idea to delivery',
    steps: [
      { icon: <FileAddOutlined />, title: 'Post your project', body: 'Describe what you need, set budget + timeline, receive bids.' },
      { icon: <TeamOutlined />,    title: 'Pick the right freelancer', body: 'Compare profiles, ratings, and chat before deciding.' },
      { icon: <CheckCircleFilled />, title: 'Track & pay securely', body: 'Payment stays in escrow until you receive and approve the work.' },
    ],
  },
};

export default function HowItWorks({ lang = 'ar' }) {
  const t = tx[lang] || tx.ar;
  return (
    <section style={{ padding: '70px 24px 60px', position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>
        <h2 className="grad-text" style={{ fontSize: 30, fontWeight: 800, margin: '0 0 8px' }}>{t.title}</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: 15, margin: '0 0 36px' }}>{t.subtitle}</p>
        <Row gutter={[20, 20]} justify="center">
          {t.steps.map((s, i) => (
            <Col xs={24} md={8} key={i}>
              <Card bordered={false} className="glass glass-hover" style={{ height: '100%', borderRadius: 20, textAlign: 'center', padding: 14 }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: '#0D7377',
                  color: '#fff', fontSize: 28,
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  marginBottom: 14,
                }}>
                  {s.icon}
                </div>
                <h3 style={{ color: 'var(--primary)', margin: '0 0 8px', fontWeight: 700 }}>
                  <span style={{ background: '#F4A623', color: '#14213D', padding: '2px 10px', borderRadius: 999, fontSize: 13, fontWeight: 800, marginInlineEnd: 8 }}>
                    {i + 1}
                  </span>
                  {s.title}
                </h3>
                <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0, lineHeight: 1.7 }}>{s.body}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}
